module.exports = __webpack_public_path__ + "img/header-decorations.1a1215dc.svg";